import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { cookieExists } from '@sxm-de/dev-kits/web-sdk/utils';
import {
    getIdentity,
    getStatusForHandle,
} from '@sxm-de/dev-kits/web-sdk/domains/identity';

export type StartPasskeyIfSupportedFn = () => Promise<unknown>;

export function initStartPasskeyIfSupportedFn({
    dependencies,
}: DomainInitPayload): StartPasskeyIfSupportedFn {
    const { appEventSdk, clientSdk } = dependencies;
    const passkeyEventName = 'passkey-event';
    const cookieName = 'SXM_PK_PROMPT';
    return async () => {
        try {
            if (!cookieExists(cookieName)) {
                const isPasskeySupported =
                    await clientSdk.user.isPasskeySupported();
                if (isPasskeySupported) {
                    appEventSdk.trackEvent({
                        event: passkeyEventName,
                        passkeyInfo: { passkeySupported: 'supported' },
                    });

                    const { handle } = await getIdentity(dependencies);
                    const handleToUse = String(
                        handle.emailAddress || handle.username,
                    );
                    const { hasPasskey } = await getStatusForHandle(
                        dependencies,
                        handleToUse,
                    );
                    appEventSdk.trackEvent({
                        event: passkeyEventName,
                        passkeyInfo: {
                            passkeyOnFile: hasPasskey
                                ? 'on file'
                                : 'not on file',
                        },
                    });

                    if (!hasPasskey) {
                        try {
                            appEventSdk.trackEvent({
                                event: passkeyEventName,
                                passkeyInfo: { passkeyEvent: 'shown' },
                            });

                            await clientSdk.user.startPasskey();
                            appEventSdk.trackEvent({
                                event: passkeyEventName,
                                passkeyInfo: { passkeyEvent: 'accepted' },
                            });
                        } catch (error: any) {
                            if (error.name === 'NotAllowedError') {
                                appEventSdk.trackEvent({
                                    event: passkeyEventName,
                                    passkeyInfo: { passkeyEvent: 'denied' },
                                });
                            } else {
                                /**
                                 * TODO:
                                 * Log error to error logger (not analytics).
                                 */
                            }
                        }
                    }
                }
                appEventSdk.trackEvent({
                    event: passkeyEventName,
                    passkeyInfo: { passkeySupported: 'not supported' },
                });

                document.cookie = `${cookieName}=;sameSite=lax;path=/;domain=.siriusxm.com`;

                return;
            } else {
                appEventSdk.trackEvent({
                    event: passkeyEventName,
                    passkeyInfo: { passkeyEvent: 'not shown-ss denied' },
                });
            }
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw error;
        }
    };
}
